import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=38f2cf5d&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=38f2cf5d&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f2cf5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f2cf5d')) {
      api.createRecord('38f2cf5d', component.options)
    } else {
      api.reload('38f2cf5d', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=38f2cf5d&scoped=true&", function () {
      api.rerender('38f2cf5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28QI5abjRefqO/JS/comp/Paginate.vue"
export default component.exports